import { LOCALE_KEYS } from "@foodlista/shared/i18n/constants"
import { z } from "zod"
import { defineOperationContext } from "../define"
import type { TranslateProductsInput } from "../schemas/translate-products"

export const translateProductsContextSchema = z.object({
	sourceLocale: z.enum(LOCALE_KEYS),
	productCount: z.number().int().nonnegative(),
})

export type TranslateProductsContext = z.infer<
	typeof translateProductsContextSchema
>

export const translateProductsContextSpec = defineOperationContext<
	TranslateProductsInput,
	TranslateProductsContext
>({
	version: 1,
	schema: translateProductsContextSchema,
	fromInput: (input) => ({
		sourceLocale: input.sourceLocale,
		productCount: input.products.length,
	}),
})
